module.exports = __webpack_public_path__ + "media/Kiki1.25bbdaba.mp3";